import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ReportChartmain from "../components/Charts/ReportChartmain";
import Bar from "../components/Charts/Bar";
import RecruitmentFunnel from "../components/Charts/RecruitmentFunnel";
import PieChart from "../components/Charts/PieChart";

const Index = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  useEffect(() => {
    // Toggle the 'toggle-sidebar' class on the <body> element
    if (isSidebarOpen) {
      document.body.classList.add("toggle-sidebar");
    } else {
      document.body.classList.remove("toggle-sidebar");
    }

    // Cleanup function to remove the class when the component is unmounted or state changes
    return () => {
      document.body.classList.remove("toggle-sidebar");
    };
  }, [isSidebarOpen]);
  return (
    <div>
    
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={isSidebarOpen} />
      <main id='main' className='main'>
        <div className='pagetitle'>
          <h1>Dashboard</h1>
          <nav>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item'>
                <a href='index.html'>Home</a>
              </li>
            </ol>
          </nav>
        </div>

        <section className='section dashboard'>
          <div className='row peichart'>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-xxl-4 col-md-6'>
                  <div className='card info-card sales-card'>
                    <div className='card-body'>
                      <h5 className='card-title'>
                        Today Leads <span></span>
                      </h5>

                      <div className='d-flex align-items-center'>
                        <div className='card-icon rounded-circle d-flex align-items-center justify-content-center'>
                          <i className='bi bi-check-circle-fill text-primary'></i>
                        </div>
                        <div className='ps-3'>
                          <h6>145</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-xxl-4 col-md-6'>
                  <div className='card info-card sales-card'>
                    <div className='card-body'>
                      <h5 className='card-title'>
                        Insta/Fb Leads <span></span>
                      </h5>

                      <div className='d-flex align-items-center'>
                        <div className='card-icon rounded-circle d-flex align-items-center justify-content-center'>
                          <i className='bi bi-instagram'></i>
                        </div>
                        <div className='ps-3'>
                          <h6>145</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-xxl-4 col-md-6'>
                  <div className='card info-card sales-card'>
                    <div className='card-body'>
                      <h5 className='card-title'>
                        Other Leads <span></span>
                      </h5>

                      <div className='d-flex align-items-center'>
                        <div className='card-icon rounded-circle d-flex align-items-center justify-content-center'>
                          <i className='bi bi-twitch'></i>
                        </div>
                        <div className='ps-3'>
                          <h6>145</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-xxl-4 col-md-6'>
                  <div className='card info-card sales-card'>
                    <div className='card-body'>
                      <h5 className='card-title'>
                        Total Clients <span></span>
                      </h5>

                      <div className='d-flex align-items-center'>
                        <div className='card-icon rounded-circle d-flex align-items-center justify-content-center'>
                          <i className='bi bi-person-circle'></i>
                        </div>
                        <div className='ps-3'>
                          <h6>145</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-xxl-4 col-md-6'>
                  <div className='card info-card sales-card'>
                    <div className='card-body'>
                      <h5 className='card-title'>
                        Total Broker <span></span>
                      </h5>

                      <div className='d-flex align-items-center'>
                        <div className='card-icon rounded-circle d-flex align-items-center justify-content-center'>
                          <i className='bi bi-briefcase-fill'></i>
                        </div>
                        <div className='ps-3'>
                          <h6>145</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-xxl-4 col-md-6'>
                  <div className='card info-card sales-card'>
                    <div className='card-body'>
                      <h5 className='card-title'>
                        Total Staff <span></span>
                      </h5>

                      <div className='d-flex align-items-center'>
                        <div className='card-icon rounded-circle d-flex align-items-center justify-content-center'>
                          <i className='bi bi-people-fill'></i>
                        </div>
                        <div className='ps-3'>
                          <h6>145</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-12'>
                  <div className='card'>
                    <div className='card-body'>
                      <h5 className='card-title'>
                        Lead By Project <span></span>
                      </h5>

                      <Bar />
                    </div>
                  </div>
                </div>


                <div className='col-12'>
                  <div className='card recent-sales overflow-auto'>
                    <div className='filter'>
                      <a className='icon' href='#' data-bs-toggle='dropdown'>
                        <i className='bi bi-three-dots'></i>
                      </a>
                      <ul className='dropdown-menu dropdown-menu-end dropdown-menu-arrow'>
                        <li className='dropdown-header text-start'>
                          <h6>Filter</h6>
                        </li>

                        <li>
                          <a className='dropdown-item' href='#'>
                            Today
                          </a>
                        </li>
                        <li>
                          <a className='dropdown-item' href='#'>
                            This Month
                          </a>
                        </li>
                        <li>
                          <a className='dropdown-item' href='#'>
                            This Year
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div className='card-body'>
                      <h5 className='card-title'>
                        Recent Sales <span>| Today</span>
                      </h5>

                      <table className='table table-border datatable'>
                        <thead>
                          <tr>
                            <th scope='col'>#</th>
                            <th scope='col'>Customer</th>
                            <th scope='col'>Product</th>
                            <th scope='col'>Price</th>
                            <th scope='col'>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th scope='row'>
                              <a href='#'>#2457</a>
                            </th>
                            <td>Brandon Jacob</td>
                            <td>
                              <a href='#' className='text-primary'>
                                At praesentium minu
                              </a>
                            </td>
                            <td>$64</td>
                            <td>
                              <span className='badge bg-success'>Approved</span>
                            </td>
                          </tr>
                          <tr>
                            <th scope='row'>
                              <a href='#'>#2147</a>
                            </th>
                            <td>Bridie Kessler</td>
                            <td>
                              <a href='#' className='text-primary'>
                                Blanditiis dolor omnis similique
                              </a>
                            </td>
                            <td>$47</td>
                            <td>
                              <span className='badge bg-warning'>Pending</span>
                            </td>
                          </tr>
                          <tr>
                            <th scope='row'>
                              <a href='#'>#2049</a>
                            </th>
                            <td>Ashleigh Langosh</td>
                            <td>
                              <a href='#' className='text-primary'>
                                At recusandae consectetur
                              </a>
                            </td>
                            <td>$147</td>
                            <td>
                              <span className='badge bg-success'>Approved</span>
                            </td>
                          </tr>
                          <tr>
                            <th scope='row'>
                              <a href='#'>#2644</a>
                            </th>
                            <td>Angus Grady</td>
                            <td>
                              <a href='#' className='text-primar'>
                                Ut voluptatem id earum et
                              </a>
                            </td>
                            <td>$67</td>
                            <td>
                              <span className='badge bg-danger'>Rejected</span>
                            </td>
                          </tr>
                          <tr>
                            <th scope='row'>
                              <a href='#'>#2644</a>
                            </th>
                            <td>Raheem Lehner</td>
                            <td>
                              <a href='#' className='text-primary'>
                                Sunt similique distinctio
                              </a>
                            </td>
                            <td>$165</td>
                            <td>
                              <span className='badge bg-success'>Approved</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className='col-12'>
                  <div className='card top-selling overflow-auto'>


                    <div className='card-body pb-0'>
                      <h5 className='card-title'>
                        Lead Stage<span></span>
                      </h5>

                      <RecruitmentFunnel />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-lg-4 '>
              <div className='card'>

                <div className='card-body'>
                  <h5 className='card-title'>
                    Recent Activity <span></span>
                  </h5>

                  <div className='activity'>
                    <div className='activity-item d-flex'>
                      <div className='activite-label'>32 min</div>
                      <i className='bi bi-circle-fill activity-badge text-success align-self-start'></i>
                      <div className='activity-content'>
                        Quia quae rerum{" "}
                        <a href='#' className='fw-bold text-dark'>
                          explicabo officiis
                        </a>{" "}
                        beatae
                      </div>
                    </div>

                    <div className='activity-item d-flex'>
                      <div className='activite-label'>56 min</div>
                      <i className='bi bi-circle-fill activity-badge text-danger align-self-start'></i>
                      <div className='activity-content'>
                        Voluptatem blanditiis blanditiis eveniet
                      </div>
                    </div>

                    <div className='activity-item d-flex'>
                      <div className='activite-label'>2 hrs</div>
                      <i className='bi bi-circle-fill activity-badge text-primary align-self-start'></i>
                      <div className='activity-content'>
                        Voluptates corrupti molestias voluptatem
                      </div>
                    </div>

                    <div className='activity-item d-flex'>
                      <div className='activite-label'>1 day</div>
                      <i className='bi bi-circle-fill activity-badge text-info align-self-start'></i>
                      <div className='activity-content'>
                        Tempore autem saepe{" "}
                        <a href='#' className='fw-bold text-dark'>
                          occaecati voluptatem
                        </a>{" "}
                        tempore
                      </div>
                    </div>

                    <div className='activity-item d-flex'>
                      <div className='activite-label'>2 days</div>
                      <i className='bi bi-circle-fill activity-badge text-warning align-self-start'></i>
                      <div className='activity-content'>
                        Est sit eum reiciendis exercitationem
                      </div>
                    </div>

                    <div className='activity-item d-flex'>
                      <div className='activite-label'>4 weeks</div>
                      <i className='bi bi-circle-fill activity-badge text-muted align-self-start'></i>
                      <div className='activity-content'>
                        Dicta dolorem harum nulla eius. Ut quidem quidem sit
                        quas
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- News & Updates Traffic --> */}
              <div className='card'>


                <div className='card-body pb-0'>
                  <h5 className='card-title'>
                    Lead Source <span></span>
                  </h5>

                  <PieChart />
                </div>
              </div>
              <div className='card'>


                <div className='card-body pb-0' >
                  <h5 className='card-title'>
                    Lead Response
                    <span></span>
                  </h5>

                  <PieChart />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
